<template>
  <Modal class="text-left">
    <h2 class="h5 mb-3">Change preview {{type}} <small v-if="!!previewItem" class="font-weight-normal cursor-pointer" @click="selectItem({key: ''})">or <u>load a demo {{type}}</u></small></h2>
    <div v-if="shopObj.password_enabled" class="font-weight-normal">
      <p>To preview a {{type}} from your store, you will need to disable password protection from your store.</p>

      <p><ExternalLink :href="'https://' + shopObj.domain + '/admin/online_store/preferences'" text="Click here to open password protection settings in your Shopify store dashboard" /></p>

      <button class="btn btn-secondary mt-3 float-right" @click="cancel">Close</button>
    </div>
    <div v-else>
      <div class="input-group">
        <input type="text" class="form-control" :placeholder="'Search for a ' + type" @input="findItem" v-model="itemQuery" />
      </div>
      <div class="nav flex-column nav-pills nav-item-list mt-3" aria-orientation="vertical" v-if="!itemLoading && items.length > 0">
        <a v-for="item in items" :key="item.key" class="nav-link d-flex justify-content-between align-items-center" @click="selectItem(item)" aria-selected="true">
          <span>{{item.title}}</span>
        </a>
      </div>
      <Loading v-if="itemLoading" class="mt-3" :box="false" :heading="false" :paragraphs="1" :lines="6" :bigLines="true" />
      <button class="btn btn-secondary mt-3 float-right" @click="cancel">Cancel</button>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash-es'
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  props: {
    type: String,
    previewItem: String
  },
  data: function () {
    return {
      items: [],
      itemQuery: '',
      itemLoading: false
    }
  },
  computed: mapState([ 'shopObj' ]),
  methods: {
    findItem: debounce(async function (e) {
      if (!e.target) return

      const query = e.target.value.trim()

      if (!query) {
        this.items = []
        return
      }

      this.itemLoading = true

      const items = await this.$API_GET('/search', { query, type: this.type, _: 1 })

      this.items = items
      this.itemLoading = false
    }, 1000),
    selectItem: function (item) {
      this.$emit('select', item.key)
    },
    cancel: function () {
      this.$emit('cancel')
    }
  }
}
</script>
